function getAllChildren(items) {
  const result = [];

  function recurse(children) {
    children.forEach((child) => {
      result.push(child);
      if (child.children && child.children.length > 0) {
        recurse(child.children);
      }
    });
  }

  recurse(items);
  return result;
}

function fieldIsActivated(field) {
  if (field.dataType === 'boolean') {
    return !!field.value;
  }

  return field.value !== null && field.value !== undefined;
}

export {
  fieldIsActivated,
  getAllChildren,
};